import axios from "axios";
import { useNavigate } from "react-router-dom"; // If using React Router

const api = axios.create({
    baseURL: "https://api.zplayer.app/api/v1",
    headers: {
        "Content-Type": "application/json",
    },
});

// Function to get token from localStorage
const getAuthToken = () => {
    const token = localStorage.getItem("authTokenZplayer");
    return token ? JSON.parse(token) : null;
};

// Request Interceptor: Automatically attach token to every request
api.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) {
            config.headers["X-CSRF-Token"] = token;
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor: Handle 401 Unauthorized
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            console.warn("Unauthorized! Redirecting to login...");
            localStorage.removeItem("authTokenZplayer"); // Clear token
            window.location.href = "/login"; // Redirect to login page
        }
        return Promise.reject(error);
    }
);

export default api;
